import React from 'react';
import { Link, Tooltip } from '@mui/material';
import { BLUE_500, GRAY_500 } from '../../constants/Colors';

interface BakeasyLinkButtonProps {
  id?: string;
  label: string;
  disabled?: boolean | false;
  fullWidth?: boolean;
  variant?: any;
  style?: React.CSSProperties;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

function BakeasyLinkButton(props: BakeasyLinkButtonProps) {
  let tooltip: string = '';
  switch (props?.id) {
    case 'contact':
    case 'storeName':
    case 'categoryName':
    case 'subCategoryName':
    case 'productName':
    case 'orderId':
      tooltip = props?.label;
      break;
  }

  return (
    <Tooltip title={tooltip}>
      <Link
        component="button"
        color={props?.disabled ? GRAY_500 : BLUE_500}
        borderColor={BLUE_500}
        onClick={props?.onClick}
        style={props?.style ?? { fontWeight: 'bold', textAlign: 'left' }}
        disabled={props?.disabled}
      >
        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {props?.label}
        </div>
      </Link>
    </Tooltip>
  );
}

export default BakeasyLinkButton;
